import {createContext} from "react";

const BillingPortfolioContext = createContext();

export default BillingPortfolioContext;